import SelectWithoutAnimantion from './SelectWithoutAnimation';

export default SelectWithoutAnimantion;
